import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_rating_active",
  "use": "sort_rating_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_rating_active\"><path fill-rule=\"evenodd\" d=\"M12.25 8 10 2 7.75 8H1l5.4 3.6L4 18l6-4 6 4-2.4-6.4L19 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol